import { ChevronDownIcon, PlugZapIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { ConnectionProviderView } from '@/lib/api/generated/model';

/**
 * Header action: connect one of the providers not yet connected. Each provider
 * holds a single connection, so a connected one is not offered again; a
 * multi-instance one (the container registry) is always offered. With nothing
 * left to add the button stays in place, disabled with the reason as its title, so
 * the page's main action never moves or disappears.
 */
export function AddConnectionMenu({
  providers,
  onSelect,
}: {
  providers: ConnectionProviderView[];
  onSelect: (provider: ConnectionProviderView) => void;
}) {
  if (providers.length === 0) {
    return (
      <Button
        size="sm"
        disabled
        title="All providers are connected"
        className="max-md:w-full"
      >
        Add connection
        <ChevronDownIcon aria-hidden="true" />
      </Button>
    );
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          // The page's main action fills a phone's width (docs/phone.md PH-03).
          <Button size="sm" className="max-md:w-full">
            Add connection
            <ChevronDownIcon aria-hidden="true" />
          </Button>
        }
      />
      <DropdownMenuContent align="end">
        {providers.map((provider) => (
          <DropdownMenuItem
            key={provider.type}
            onClick={() => {
              onSelect(provider);
            }}
          >
            <PlugZapIcon aria-hidden="true" />
            {provider.display_name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
